export enum DashboardType {
  account = "account",
  orders = "orders",
  refunds = "refunds",
  security = "security",
  wallet = "wallet",
}
